/** Gen1MasterItem の IsPurchasedOnly フラグを真偽値に正規化する。 */
export function isPurchasedOnlyFlag(value) {
    if (value === true || value === 1) return true;
    const normalized = String(value ?? '').trim().toLowerCase();
    return normalized === '1' || normalized === 'true';
}
